import { Card, Divider, Space } from "antd";
import { useOutletContext, useParams } from "react-router";
import MessageCard from "../../components/cards/MessageCard";
import AssignResourceDomainSteps from "../../components/settings/AssignResourceDomainSteps";
import { IResourceDetails } from "../../types";

const ResourceSettingsCustomDomain = () => {
    const { envId } = useParams();
    const { resourceDetails } = useOutletContext<{ resourceDetails: IResourceDetails }>();

    return (
        <Space direction="vertical" className="full-width">
            {
                resourceDetails.domain.eligibleForDomainConfiguration ?
                    <Card>
                        <Card.Meta
                            title="Assign domain"
                            description={
                                <>
                                    In order to enable external access from the Internet to your deployed application, you need to assign a domain.<br />
                                    If you have already configured a domain, you may change it here.
                                </>
                            }
                        />
                        <Divider />
                        <MessageCard
                            type="domain-info"
                            style={{ marginBottom: 30 }}
                            text={
                                <div>
                                    <div style={{ fontWeight: 600 }}>
                                        Your application is exposed on <a href={resourceDetails.domain.accessUrl} target="_blank" rel="noreferrer">{resourceDetails.domain.accessUrl}</a>
                                    </div>
                                    <div>
                                        If you want to change the domain, follow the steps below.
                                    </div>
                                </div>
                            }
                            showIcon={false}
                        />
                        <AssignResourceDomainSteps
                            envId={envId!}
                            resourceName={resourceDetails.name}
                            resourceVersion={resourceDetails.version}
                            domainCNAME={resourceDetails.domain.CNAME!}
                            isModal={false}
                            customDomainName={resourceDetails.domain.displayAssignDomainBtn ? undefined : resourceDetails.domain.accessUrl}
                            awsAccount={{
                                id: resourceDetails.awsAccountId,
                                // CloudFront only supports ACM certificates in the N. Virginia Region (us-east-1)
                                region: resourceDetails.domain.CNAME!.endsWith("cloudfront.net") ?
                                    "us-east-1" :
                                    resourceDetails.awsRegion
                            }}
                        />
                    </Card> :
                    <Card>
                        <Card.Meta
                            title="Assign domain"
                            description="Domain configuration is not supported for this type of resource"
                        />
                    </Card>
            }
        </Space >
    );
}

export default ResourceSettingsCustomDomain;